var map = {
	"./border_bottom.png": "cdeb",
	"./border_bottom_left.png": "1302",
	"./border_bottom_right.png": "a418",
	"./border_top.png": "22fd",
	"./border_top_left.png": "d2e6",
	"./border_top_right.png": "365f",
	"./hex_arctic.png": "d545",
	"./hex_blank.png": "39b7",
	"./hex_desert.png": "ac09",
	"./hex_forest.png": "2c6f",
	"./hex_grassland.png": "4a00",
	"./hex_hills.png": "ee71",
	"./hex_mountain.png": "e838",
	"./hex_plain.png": "6387",
	"./hex_sea.png": "5908",
	"./hex_shore.png": "e00e",
	"./hex_template.png": "0cf4",
	"./tiles_spritesheet": "fc9b",
	"./tiles_spritesheet.json": "fc9b",
	"./tiles_spritesheet.png": "84c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9ad";